export * from './input-switch.module';
export * from './input-switch.component';
